import { forceRefreshAnalytics, getBankConnections, getCategories, getFeed, getSpaceInvites, } from 'actions';
import { CONNECTIONS_REQUEST as CONNECTION_REQUEST_TYPE, USER_SUCCESS, } from 'actions/types';
import { put, select, takeEvery, takeLatest, putResolve, call, } from 'typed-redux-saga/macro';
import { differenceInDays, parseISO } from 'date-fns';
import { selectUserDefaultSpaceId } from 'reducers/selectors';
import { getPotsAccount, getSpacePots } from 'features/pots/actions';
import { IAP_PURCHASE_FLOW_ENDED_WITH_SUCCESS } from 'features/premium/actions';
import { getSpaceTradingAccounts, getTradingAccounts } from 'actions/invest';
import { switchedSpace, getSpaceInfo, getMySpaces, setSelectedSpace, saveLastUsedSpace, getInvitesForSpace, } from '../actions';
import { SELECTED_SPACE, FETCH_SPACES, EDIT_SPACE_INFO, GET_SPACE_INFO_SUCCESS, GET_SPACE_INFO_FAILURE, SET_SPACE_NAME_SUCCESS, apiEvents, DELETE_SPACE_SUCCESS, } from '../constants';
import { selectPreviousSelectedSpace, selectSelectedSpaceData, selectSelectedSpace, selectHasSpaces, } from '../reducers/selectors';
import { SpaceReminderModal } from '../components/SpaceReminderModal';
function* refreshSpaceAccounts() {
    const space = yield* select(selectSelectedSpaceData);
    if (space && !space.isDefault) {
        yield* put(getMySpaces());
        yield* put(getSpaceInfo(space.id));
    }
}
function* updateSpaceWealthAccountsWorker(spaceId) {
    yield* put(getSpacePots(spaceId));
    yield* put(getSpaceTradingAccounts(spaceId));
}
function* changeSpace(action) {
    const id = action.payload;
    const previousSpace = yield* select(selectPreviousSelectedSpace);
    if (id !== previousSpace && id !== undefined) {
        yield* put(getSpaceInfo(id));
        yield* put(getFeed());
        yield* put(forceRefreshAnalytics());
        yield* put(getCategories());
        yield* put(switchedSpace());
        yield* put(saveLastUsedSpace(id));
        yield* call(updateSpaceWealthAccountsWorker, id);
    }
}
export function* fetchSpacesSaga() {
    const response = (yield* putResolve(getMySpaces()));
    yield* putResolve(getSpaceInvites('PENDING'));
    if (response?.type !== 'GET_SPACES_SUCCESS')
        return;
    const { spaces } = response.payload;
    const defaultSpace = spaces.find((space) => space.isDefault);
    const selection = yield* select(selectSelectedSpace);
    const selectedSpace = spaces.find((space) => space.id === selection);
    const hideSpaceReminderModal = yield* select((state) => state.deviceSettings.hideSpaceReminderModal);
    const hasSpaces = yield* select(selectHasSpaces);
    const lastSession = yield* select((state) => state.user.lastSession);
    if (selection && !selectedSpace) {
        if (defaultSpace) {
            yield* put(setSelectedSpace(defaultSpace.id));
        }
    }
    const finalSelection = yield* select(selectSelectedSpace);
    if (finalSelection) {
        yield* put(getSpaceInfo(finalSelection));
        yield* call(updateSpaceWealthAccountsWorker, finalSelection);
    }
    if (!hideSpaceReminderModal &&
        hasSpaces &&
        selectedSpace &&
        (selectedSpace.isDefault || selectedSpace.isPremium) &&
        lastSession?.time &&
        differenceInDays(new Date(), parseISO(lastSession.time)) >= 7) {
        SpaceReminderModal.show(selectedSpace);
    }
}
export function* refreshSpaceAndFeed(action) {
    const { lastUsedSpaceId } = action.payload;
    const selectedSpace = yield* select(selectSelectedSpace);
    const spaceId = lastUsedSpaceId || selectedSpace;
    const previousSpace = yield* select(selectPreviousSelectedSpace);
    if (spaceId && spaceId !== previousSpace) {
        yield* call(changeSpace, { payload: spaceId, type: SELECTED_SPACE });
    }
}
function* refreshPotsWalletInvestOnSpaceEdit(action) {
    const { spaceId } = action.payload;
    yield* put(getTradingAccounts());
    yield* put(getPotsAccount());
    yield* call(updateSpaceWealthAccountsWorker, spaceId);
    yield* put(getSpaceInfo(spaceId));
}
function* updateSpacePotsWalletInvest(action) {
    const { id: spaceId } = action.payload.space;
    yield* putResolve(getInvitesForSpace(spaceId));
    yield* call(updateSpaceWealthAccountsWorker, spaceId);
}
function* deleteSpaceSaga(action) {
    const { defaultSpaceId } = action.payload;
    yield* call(fetchSpacesSaga);
    yield* putResolve(getPotsAccount());
    yield* putResolve(getTradingAccounts());
    yield* putResolve(getBankConnections());
    yield* putResolve(getSpaceInfo(defaultSpaceId));
}
function* handleSpaceInfoFailure() {
    const userDefaultSpaceId = yield* select(selectUserDefaultSpaceId);
    if (userDefaultSpaceId) {
        yield* put(setSelectedSpace(userDefaultSpaceId));
        yield* call(fetchSpacesSaga);
    }
}
function* spaceSaga() {
    log('[spaceSaga] starting...', false, 'cyan');
    yield* takeLatest(SELECTED_SPACE, changeSpace);
    yield* takeLatest(FETCH_SPACES, fetchSpacesSaga);
    yield* takeLatest(USER_SUCCESS, refreshSpaceAndFeed);
    yield* takeEvery(DELETE_SPACE_SUCCESS, deleteSpaceSaga);
    yield* takeEvery(SET_SPACE_NAME_SUCCESS, fetchSpacesSaga);
    yield* takeEvery(CONNECTION_REQUEST_TYPE, refreshSpaceAccounts);
    yield* takeEvery(GET_SPACE_INFO_FAILURE, handleSpaceInfoFailure);
    yield* takeEvery(apiEvents.rejectSpaceInvite[1], fetchSpacesSaga);
    yield* takeEvery('INVITE_PEOPLE_TO_SPACE_SUCCESS', fetchSpacesSaga);
    yield* takeEvery(EDIT_SPACE_INFO, refreshPotsWalletInvestOnSpaceEdit);
    yield* takeLatest(GET_SPACE_INFO_SUCCESS, updateSpacePotsWalletInvest);
    yield* takeLatest(IAP_PURCHASE_FLOW_ENDED_WITH_SUCCESS, fetchSpacesSaga);
}
export default spaceSaga;
